import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_product",
  ref: "merchantOrderList",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_product_header"
}
const _hoisted_5 = { class: "w-100 d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = { class: "fs-6 text-gray-400" }
const _hoisted_8 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "modal-body p-0" }
const _hoisted_13 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_product_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_product_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_product_scroll",
  "data-kt-scroll-offset": "250px"
}
const _hoisted_14 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = {
  class: "table align-middle table-hover fs-5 dataTable no-footer",
  role: "grid"
}
const _hoisted_17 = { class: "fw-bold text-gray-800" }
const _hoisted_18 = { class: "border-0" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onUpdate:modelValue", "disabled"]
const _hoisted_23 = {
  colspan: "3",
  class: "text-start"
}
const _hoisted_24 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_25 = { class: "mb-1 text-line-clamp-1 fw-boldest" }
const _hoisted_26 = { class: "fs-6 text-gray-400" }
const _hoisted_27 = {
  colspan: "3",
  class: "text-start"
}
const _hoisted_28 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_29 = { class: "mb-1 text-line-clamp-1 fw-boldest" }
const _hoisted_30 = { class: "fs-6 text-gray-400" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_33 = { class: "mb-1" }
const _hoisted_34 = { class: "fs-6 text-gray-400" }
const _hoisted_35 = { class: "text-end" }
const _hoisted_36 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_37 = { class: "mb-1" }
const _hoisted_38 = { class: "fs-6 text-gray-400 text-nowrap" }
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "svg-icon svg-icon-3 icon-plus" }
const _hoisted_42 = { class: "svg-icon svg-icon-3 icon-minus" }
const _hoisted_43 = { class: "text-start" }
const _hoisted_44 = { class: "d-flex" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onUpdate:modelValue", "disabled"]
const _hoisted_47 = {
  colspan: "3",
  class: "text-start"
}
const _hoisted_48 = {
  colspan: "3",
  class: "text-start"
}
const _hoisted_49 = { class: "text-end" }
const _hoisted_50 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_51 = { class: "mb-1" }
const _hoisted_52 = { class: "fs-6 text-gray-400" }
const _hoisted_53 = { class: "text-end" }
const _hoisted_54 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_55 = { class: "mb-1" }
const _hoisted_56 = { class: "fs-6 text-gray-400 text-nowrap" }
const _hoisted_57 = {
  colspan: "10",
  class: "p-0"
}
const _hoisted_58 = {
  key: 0,
  class: "separator"
}
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  colspan: "10",
  class: "dataTables_empty"
}
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { class: "modal-footer flex-right" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = { class: "indicator-label" }
const _hoisted_68 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_69 = { class: "indicator-progress" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.t("orderRequest.toBeInvoicedOrders")), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.merchantMap.get(String(_ctx.merchantId))?.label), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_form_item, { prop: "ids" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "items" }, null, 512), [
                [_vShow, false]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("table", _hoisted_16, [
                          _createElementVNode("tbody", _hoisted_17, [
                            (_ctx.formData.items.length !== 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formData.items, (item, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    _createElementVNode("tr", _hoisted_18, [
                                      _createElementVNode("td", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                          _createElementVNode("label", {
                                            class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                                      'cursor-nodrop': _ctx.loading,
                                    }]),
                                            onClick: _withModifiers(($event: any) => (_ctx.toggleItemSelect(item)), ["stop"])
                                          }, [
                                            _withDirectives(_createElementVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              "onUpdate:modelValue": ($event: any) => ((item.isChecked) = $event),
                                              disabled: _ctx.loading
                                            }, null, 8, _hoisted_22), [
                                              [_vModelCheckbox, item.isChecked]
                                            ])
                                          ], 10, _hoisted_21)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.request_number), 1),
                                          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formatDate(item.request_date)), 1)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.t("orderRequest.reference")), 1),
                                          _createElementVNode("span", _hoisted_30, _toDisplayString(item.reference), 1)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.t("order.qty")), 1),
                                          _createElementVNode("span", _hoisted_34, _toDisplayString(item.total_qty), 1)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, [
                                          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.t("orderRequest.totalAmount")), 1),
                                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$currency.currency(
                                        item.total_net_amount,
                                        2,
                                        ",",
                                        ".",
                                        "€ "
                                      )), 1)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_39, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: _normalizeClass(["btn btn-icon toggle-btn btn-bg-light btn-active-color-primary btn-sm", { active: item.isExpand }]),
                                          onClick: ($event: any) => (_ctx.expandSub(item))
                                        }, [
                                          _createElementVNode("span", _hoisted_41, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                                          ]),
                                          _createElementVNode("span", _hoisted_42, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr090.svg" })
                                          ])
                                        ], 10, _hoisted_40)
                                      ])
                                    ]),
                                    (item.items.length)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.items, (row, rowIndex) => {
                                          return _withDirectives((_openBlock(), _createElementBlock("tr", {
                                            class: _normalizeClass(["subtable_template order-assign-merchant-order-list text-start text-xs border-dashed", {
                                  'border-0':
                                    rowIndex === item.items.length - 1,
                                }]),
                                            key: rowIndex
                                          }, [
                                            _createElementVNode("td", _hoisted_43, [
                                              _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("label", {
                                                  class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                                        'cursor-nodrop': _ctx.loading,
                                      }]),
                                                  onClick: _withModifiers(($event: any) => (_ctx.toggleSubSelect(item, row)), ["stop"])
                                                }, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": ($event: any) => ((row.isChecked) = $event),
                                                    disabled: _ctx.loading
                                                  }, null, 8, _hoisted_46), [
                                                    [_vModelCheckbox, row.isChecked]
                                                  ])
                                                ], 10, _hoisted_45)
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_47, [
                                              _createVNode(_component_product_info, {
                                                gallery: [
                                      {
                                        id: 0,
                                        origin_url: row.__show.product_gallery,
                                      },
                                    ],
                                                name: row.__show.product_name,
                                                name_en: row.__show.product_name,
                                                source_link: '',
                                                brand_id: row.__show.brand_name
                                              }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                                            ]),
                                            _createElementVNode("td", _hoisted_48, [
                                              _createVNode(_component_sku_info, {
                                                brand_article_no: row.__show.article_no,
                                                color: row.__show.color,
                                                size: row.__show.size,
                                                product_identifier_id: 
                                      row.__show.product_identifier_id
                                    
                                              }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
                                            ]),
                                            _createElementVNode("td", _hoisted_49, [
                                              _createElementVNode("div", _hoisted_50, [
                                                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.t("order.qty")), 1),
                                                _createElementVNode("span", _hoisted_52, _toDisplayString(row.qty), 1)
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_53, [
                                              _createElementVNode("div", _hoisted_54, [
                                                _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.t("order.grandTotalBase")), 1),
                                                _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$currency.currency(
                                          row.qty * Number(row.unit_net_amount),
                                          2,
                                          ",",
                                          ".",
                                          "€ "
                                        )), 1)
                                              ])
                                            ])
                                          ], 2)), [
                                            [_vShow, item.isExpand]
                                          ])
                                        }), 128))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_57, [
                                        (index != _ctx.formData.items.length - 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_58))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ], 64))
                                }), 128))
                              : (_openBlock(), _createElementBlock("tr", _hoisted_59, [
                                  _createElementVNode("td", _hoisted_60, [
                                    _createElementVNode("p", null, [
                                      (!_ctx.loading)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, "No data found"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                          ])
                        ])
                      ]),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("button", {
                  ref: "submitButton",
                  type: "submit",
                  class: "btn btn-lg btn-primary",
                  disabled: _ctx.isDisabledSubmit
                }, [
                  _createElementVNode("span", _hoisted_67, [
                    _createElementVNode("span", _hoisted_68, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.add")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_69, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_70
                  ])
                ], 8, _hoisted_66)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ], 512))
}